import { TFunction } from "i18next";

export const licenseNumberForView = (targetNum: string) => {
  if (!targetNum) {
    return "";
  }
  return targetNum.substring(0, 4) + "-" + targetNum.substring(4, 8) + "-" + targetNum.substring(8, 12);
};

export const contractTypeForView = (contractType: string, t: TFunction) => {
  if (!contractType) {
    return "";
  }
  return contractType === "ricoh" ? t("admin.ricohContractType") : t("admin.distributorContractType");
};

export const useCategoryForView = (useCategory: string, t: TFunction) => {
  if (!useCategory) {
    return "";
  }

  if (useCategory === "customer") {
    return t("admin.customerCategory");
  }
  if (useCategory === "demo") {
    return t("admin.demoCategory");
  }
  return t("admin.practiceCategory");
};
